<template>
  <div>
    <h2>Vaihda salasana:</h2>
    <form v-if="!done" @submit.prevent="onSubmit()">
      <fieldset>
        <div class="line">
          <label for="changepass-password">Vanha salasana:</label>
          <input v-model="password" type="password" name="password" id="changepass-password" autocomplete="password">
        </div>
        <div class="line">
          <label for="changepass-new-password">Uusi salasana:</label>
          <input
            @input="onNewPasswordInput"
            @blur="validateNewPassword"
            v-model="newpassword"
            type="password"
            name="newpassword"
            id="changepass-new-password"
            autocomplete="new-password">
        </div>
        <div class="line">
          <label for="changepass-new-password2">Uusi salasana uudelleen:</label>
          <input
            @input="onNewPasswordInput"
            @blur="validateNewPassword"
            v-model="newpassword2"
            type="password"
            name="newpassword2"
            id="changepass-new-password2"
            autocomplete="new-password">
          <span v-if="error.passwordMatch" class="error">Salasanat eivät täsmää!</span>
        </div>
        <div v-if="!loading" class="line">
          <button type="submit">Vaihda salasana</button>
        </div>
        <div v-else class="line done">
          <p>Vaihdetaan salasanaa...</p>
        </div>
      </fieldset>
    </form>
    <div v-else>Salasana vaihdettiin onnistuneesti.</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Auth from './../store/modules/auth/types';

export default {
  name: 'ChangePasswordView',
  data () {
    return {
      error: {
        passwordMatch: false
      },
      password: '',
      newpassword: '',
      newpassword2: '',
      loading: false,
      done: false,
    }
  },
  computed: {
  },
  methods: {
    onSubmit () {
      this.loading = true;
      console.log('onsubmit');
      this.changePassword({password: this.password, newPassword: this.newpassword}).then(() => {
        this.loading = false;
        this.done = true;
      })
    },
    onNewPasswordInput () {
      if (this.error.passwordMatch) {
        this.validateNewPassword();
      }
    },
    validateNewPassword () {
      if (this.newpassword !== this.newpassword2) {
        this.error.passwordMatch = true;
      } else {
        this.error.passwordMatch = false;
      }
    },
    ...mapActions('Auth', [Auth.actions.CHANGE_PASSWORD])
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChangePasswordView.vue